import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
} from "@mui/material";
import Label from "src/components/Label";
import moment from "moment";
import { UserListHead } from "./user";

const TABLE_HEAD = [
  { id: "name", label: "Name", alignRight: false },
  { id: "email", label: "Email", alignRight: false },
  { id: "date", label: "Created Date", alignRight: false },
  { id: "status", label: "Status", alignRight: false },
];

export default function RecentMembersTable({ recentMember }) {
  return (
    <Card
      style={{ overflowX: "auto" }}
      sx={{
        width: "100%",
        height: "100%",
        maxHeight: 300,
        display: "flex",
        borderRadius: 2,
        flexDirection: "column",
        boxShadow: 2,
      }}
    >
      <h3 className="ms-3 mt-3">Recent Members</h3>
      <TableContainer sx={{ minWidth: 450 }}>
        <Table size="small">
          <UserListHead
            headLabel={TABLE_HEAD}
            rowCount={recentMember?.length}
          />
          <TableBody>
            {recentMember?.map((row, i) => {
              const {
                first_name: name,
                last_name: lastName,
                status,
                email,
                createdAt,
              } = row;
              return (
                <TableRow hover key={i} tabIndex={-1} role="checkbox">
                  <TableCell>
                    <Typography>{name + " " + lastName}</Typography>
                  </TableCell>

                  <TableCell>
                    <Typography>{email}</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography sx={{ ml: 1 }}>
                      {createdAt
                        ? moment(createdAt).format(" DD-MM-YYYY")
                        : "N/A"}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Label
                      variant="ghost"
                      color={status === false ? "error" : "success"}
                    >
                      {status === false ? "InActive" : "Active"}
                    </Label>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
